export default "__VITE_ASSET__dNqZ8ohQ__"